import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]

import UserIcon from "@/assets/images/user-icon.svg"
  interface Props {
    name: string
    image: string
    color?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'avatarTemplate',
  props: {
    name: null,
    image: null,
    color: { default: "#F8EEF0" }
  },
  setup(__props: any) {

const props = __props as { name: string, image: string, color: string }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "h-[45px] w-[45px] pt-2 rounded-full border",
    style: _normalizeStyle({
      borderColor: props.color ? props.color : '#7442c8',
    })
  }, [
    (props.image && props.image.length)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "rounded-full object-contain p-[2px] -mt-[9px] h-[45px] w-[45px]",
          src: props.image,
          alt: props.name
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "rounded-full object-contain p-[2px] -mt-[9px] h-[45px] w-[45px]",
          src: _unref(UserIcon),
          alt: props.name
        }, null, 8, _hoisted_2))
  ], 4))
}
}

})